import { fetchUser, selectUser, selectUserFetchStatus } from '../../slices/user/userSlice';
import { useCallback, useEffect } from 'react';
import { LOCATION_EXCEPTIONS } from '../constants/location_exceptions';
import { useAppDispatch } from './useAppDispatch';
import { useAuth } from '@clerk/clerk-react';
import { useAppSelector } from './useAppSelector';

export const useUserInfo = () => {
  const dispatch = useAppDispatch();
  const { isSignedIn } = useAuth();
  const fetchUserStatus = useAppSelector(selectUserFetchStatus);
  const currentUser = useAppSelector(selectUser);

  const locationIncludeExceptionUrl = LOCATION_EXCEPTIONS.some((el) => {
    return location.pathname.includes(el);
  });

  const shouldFetchUser = isSignedIn && !currentUser?.id && !locationIncludeExceptionUrl;

  const getUser = useCallback(() => {
    if (shouldFetchUser) {
      dispatch(fetchUser());
    }
  }, [shouldFetchUser, dispatch]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return {
    currentUser,
    userLoading: fetchUserStatus === 'loading',
  };
};
